import { createDuoToneIcon } from './helpers/createDuoToneIcon'

export const ErrorDuoTone = createDuoToneIcon(
  'ErrorDuoTone',
  [
    [
      'path',
      {
        d: 'M15.5967 1.13867C16.2545 1.2042 16.8722 1.49624 17.3438 1.96777L22.0332 6.65527H22.0322C22.5714 7.19424 22.8748 7.92518 22.875 8.6875V15.3125C22.8748 16.0747 22.5711 16.8048 22.0322 17.3438L17.3447 22.0332L17.3438 22.0322C16.8048 22.5711 16.0747 22.8748 15.3125 22.875H8.6875C7.92518 22.8748 7.19424 22.5714 6.65527 22.0322L1.9668 17.3447L1.96777 17.3438C1.42885 16.8048 1.12525 16.0747 1.125 15.3125V8.6875L1.13867 8.40332C1.20421 7.74535 1.49604 7.12686 1.96777 6.65527L6.65527 1.9668V1.96777C7.19424 1.42864 7.92518 1.12525 8.6875 1.125H15.3125L15.5967 1.13867Z',
        stroke: 'none',
        key: 'ErrorDuoTone-0',
      },
    ],
    [
      'path',
      {
        d: 'M12 15.1152C12.4832 15.1152 12.875 15.507 12.875 15.9902V16C12.875 16.4832 12.4832 16.875 12 16.875C11.5168 16.875 11.125 16.4832 11.125 16V15.9902C11.125 15.507 11.5168 15.1152 12 15.1152ZM12 7.11328C12.4832 7.11328 12.875 7.50503 12.875 7.98828V12.4883C12.875 12.9715 12.4832 13.3633 12 13.3633C11.5168 13.3633 11.125 12.9715 11.125 12.4883V7.98828C11.125 7.50503 11.5168 7.11328 12 7.11328Z',
        stroke: 'none',
        key: 'ErrorDuoTone-1',
      },
    ],
  ],
  {
    foregroundStartIndex: 1,
    defaultGradient: 'red',
    defaultForegroundClassName: 'fill-background',
  },
)

ErrorDuoTone.displayName = 'ErrorDuoTone'
